export const externalRessources = {
  hotDimensioningBlockpadLink:
    'https://drive.google.com/drive/folders/1rA7kujNDAw3zSWcrG45Fd_CS0FtHJiro?usp=drive_link',
}
